// This needs to be the first import!!!
// With the following line Webpack is able to dynamically adapt the URL to our assets.
// We are using the staticHost var which we get from the server based on the env.
// https://webpack.js.org/guides/public-path/#on-the-fly
// @ts-ignore
// eslint-disable-next-line @typescript-eslint/camelcase, camelcase, no-undef
__webpack_public_path__ = window.staticHost;
